import { render, staticRenderFns } from "./BmvInput.vue?vue&type=template&id=ea626570&scoped=true"
import script from "./BmvInput.vue?vue&type=script&lang=js"
export * from "./BmvInput.vue?vue&type=script&lang=js"
import style0 from "./BmvInput.vue?vue&type=style&index=0&id=ea626570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea626570",
  null
  
)

export default component.exports